<template>
  <transition name="fade">
    <div class="login-container">
      <div class="login-wrapper">
        <div class="login-title">LUPA PASSWORD</div>
        <div style="margin-top:20px">
          <div class="login-input">
            <label for="">Email</label>
            <input
              type="email"
              placeholder="cth: nama@email.com"
              v-model="email"
            />
          </div>
        </div>
        <div class="one-btn-center">
          <div class="btn-small">
            <div
              class="btn-wrapper btn-wrapper__transparent-red"
              @click="closeModal()"
            >
              Batal
            </div>
          </div>
          <div class="btn-small">
            <div
              class="btn-wrapper btn-wrapper__transparent-red"
              @click="forgot()"
            >
              Kirim
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { api } from '@/services/config'
import axios from 'axios'
export default {
  data() {
    return {
      email: '',
    }
  },
  methods: {
    closeModal() {
      this.$store.commit('SET_MODAL_FORGOT', false)
    },
    async forgot() {
      const self = this
      const url = `${api}/api/v1/auth/forget`
      const authData = {
        email: this.email,
      }

      this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
      try {
        const { data: auth } = await axios({
          method: 'POST',
          url,
          data: authData,
        })

        if (auth && auth.data) {
          self.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          self.$store.commit('SET_MODAL_FORGOT', false)
          self.$store.commit(
            'SET_NOTIF',
            'Silahkan Cek Email anda untuk mereset password'
          )
        }
      } catch (error) {
        self.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
        self.$store.commit(
          'SET_NOTIF',
          self.$get(error, 'response.data.message', 'Server Error')
        )
      }
    },
  },
}
</script>
